@if (navItems$ | async; as navItems) {
  <nav class="ssr-navigation" [attr.aria-label]="'common.menu' | cxTranslate">
    <ul class="ssr-navigation-lvl-1">
      @for (item of navItems; track $index) {
        <li>
          <app-link
            class="ssr-navigation-link"
            [link]="item.url"
            [maskLink]="item.maskLink"
            [shopItem]="item.shopItem"
          >
            <span>{{ item.name }}</span>
          </app-link>

          @if (item.children.length) {
            @if (item.shopItem) {
              <div class="ssr-shopbar">
                <ul class="ssr-shopbar-list">
                  @for (category of item.children; track $index) {
                    <li>
                      <app-link class="ssr-shopbar-link" [link]="category.url">
                        <span>{{ category.name }}</span>
                      </app-link>

                      @if (category.children.length) {
                        <ng-container
                          *ngTemplateOutlet="flyout; context: { $implicit: category }"
                        ></ng-container>
                      }
                    </li>
                  }
                </ul>
              </div>
            } @else {
              <ng-container *ngTemplateOutlet="flyout; context: { $implicit: item }"></ng-container>
            }
          }
        </li>
      }
    </ul>
  </nav>
}

<ng-template #flyout let-item>
  <div class="ssr-flyout">
    <div class="ssr-flyout-content">
      <div class="ssr-flyout-title">{{ item.name }}</div>

      <div class="ssr-flyout-list">
        <ng-container *ngTemplateOutlet="column; context: { $implicit: item }"></ng-container>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #column let-item>
  <ul class="ssr-flyout-col">
    <li>
      <app-link class="ssr-flyout-showall" [link]="item.url">
        <span>{{
          (item.isCategory ? 'common.viewAll' : 'common.overviewPage') | cxTranslate
        }}</span>
      </app-link>
    </li>

    @for (child of item.children; track $index) {
      <li>
        <app-link class="ssr-flyout-link" [link]="child.url" [maskLink]="child.maskLink">
          <span>{{ child.name }}</span>

          @if (child.children.length) {
            <app-svg iconName="chevron-right" dimension="1.6rem"></app-svg>
          }
        </app-link>

        @if (child.children.length) {
          <ng-container *ngTemplateOutlet="column; context: { $implicit: child }"></ng-container>
        }
      </li>
    }
  </ul>
</ng-template>
